<template>
  <div class="page">
    <div class="screenLine">
      <el-input
        @keyup.enter.native="handelComClick"
        v-model="keyword"
        placeholder="订单号/用户/商品"
        style="width: 240px; margin-right: 16px"
      ></el-input>
      <div>订单状态：</div>
      <el-select v-model="state" placeholder="订单状态" class="titleSelect" @change="handelComClick">
        <el-option
          v-for="item in stateList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <div>下单日期：</div>
      <el-date-picker
        v-model="date"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="margin-right:16px"
        @change="handelComClick"
      ></el-date-picker>
      <el-button type="warning" plain @click="handleResetClick">重置</el-button>
      <el-button type="warning" @click="handlePickUp">自提核销</el-button>
    </div>
    <div class="screenLineR">
      <div class="tabView">
        <div :class="tab == 0?'tabActiveItem':'tabItem'" @click="handleTabClick(0)">全部订单</div>
        <div :class="tab == 1?'tabActiveItem':'tabItem'" @click="handleTabClick(1)">商品订单</div>
        <div :class="tab == 2?'tabActiveItem':'tabItem'" @click="handleTabClick(2)">活体订单</div>
        <div :class="tab == 3?'tabActiveItem':'tabItem'" @click="handleTabClick(3)">虚拟订单</div>
        <div :class="tab == 4?'tabActiveItem':'tabItem'" @click="handleTabClick(4)">处方订单</div>
        <div :class="tab == 5?'tabActiveItem':'tabItem'" @click="handleTabClick(5)">问诊订单</div>
      </div>
    </div>
    <div class="tableBox">
      <el-table :data="tableData" style="width: 100%;height: 100%;">
        <el-table-column prop="no" label="消费订单"></el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.order_type_id == 1">商品</span>
            <span v-if="scope.row.order_type_id == 8">活体</span>
            <span v-if="scope.row.order_type_id == 9">虚拟</span>
          </template>
        </el-table-column>
        <el-table-column label="下单日期">
          <template
            slot-scope="scope"
          >{{ $public.FTime(scope.row.create_time, "YYYY-MM-DD HH:mm:ss") }}</template>
        </el-table-column>
        <el-table-column prop="user_info.nick_name" label="用户"></el-table-column>
        <el-table-column prop="user_info.user_mobile" label="电话"></el-table-column>
        <el-table-column prop="total_price" label="结算金额"></el-table-column>
        <el-table-column label="结算方式">
          <template slot-scope="scope">
            <template v-if="scope.row.pay_info != null">
              <div v-for="(item, index) in scope.row.pay_info.pay_list" :key="index">
                <template v-if="item.pay_type == 1">支付宝</template>
                <template v-if="item.pay_type == 2">微信</template>
                <template v-if="item.pay_type == 7">余额</template>
                <template v-if="item.pay_type == 17">拉卡拉</template>
                <template v-if="item.pay_type == 9">积分</template>
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="订单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 1">已创建</span>
            <span v-if="scope.row.state == 2">支付中</span>
            <span v-if="scope.row.state == 3">支付成功</span>
            <span v-if="scope.row.state == 4">已接单</span>
            <span v-if="scope.row.state == 5">已发货</span>
            <span v-if="scope.row.state == 8">已完成</span>
            <span v-if="scope.row.state == -2">已取消</span>
            <span v-if="scope.row.state == -3">退款中</span>
            <span v-if="scope.row.state == -4">退款成功</span>
          </template>
        </el-table-column>
        <el-table-column label="配送方式" v-if="tableData.order_type_id==1">
          <template slot-scope="scope" v-if="scope.row.online_order_data">
            <span v-if="scope.row.online_order_data.distribution_type == 1">邮递配送</span>
            <span v-if="scope.row.online_order_data.distribution_type == 2">门店自提</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="订单备注">
          <template slot-scope="scope">{{ scope.row.remark == '' ? '--' : scope.row.remark }}</template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleSeeClick(scope.row)">查看</el-button>

            <el-button
              type="text"
              size="small"
              v-if="scope.row.online_order_data != null && scope.row.online_order_data.pick_up_store && scope.row.online_order_data.pick_up_store.code != null && scope.row.online_order_data.distribution_type == 2 && scope.row.state == 5"
              @click="cancel(scope.row)"
            >核销</el-button>
          </template>
        </el-table-column>
      </el-table>
      <page :page="page.page" :total="page.total" @change="changePage" style="margin: 10px 0;"></page>
    </div>
    <el-dialog
      title="自提订单核销"
      :modal-append-to-body="false"
      :visible.sync="dialogconfirm_state"
      width="20%"
    >
      <!--  :before-close="handleClose" -->
      <el-form>
        <el-form-item label="录入核销码">
          <el-input type="input" v-model="pick_up_store_code"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogconfirm_state = false">取 消</el-button>
        <el-button type="primary" @click="confirmSort">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑 -->
    <div v-if="drawerPickUp_state">
      <drawerPickUp @closeOn="handleUploadClose" :comState="drawerPickUp_state"></drawerPickUp>
    </div>
  </div>
</template>
  
<script>
import drawerPickUp from "./drawerPickUp.vue";
import page from "../../../../components/page.vue";
export default {
  components: {
    page,
    drawerPickUp
  },
  data() {
    return {
      page: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      tab: 0,
      order_id: "",
      type: "",
      date: "", //日期
      state: "",
      keyword: "", //关键字
      tableData: [], //订单列表
      sort: "", //核销码
      dialogconfirm_state: false,
      drawerPickUp_state: false,
      pick_up_store_code: "", //核销 核销码
      stateList: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "已创建",
          value: "1"
        },
        {
          label: "支付中",
          value: "2"
        },
        {
          label: "支付成功",
          value: "3"
        },
        {
          label: "已发货",
          value: "5"
        },
        {
          label: "已完成",
          value: "8"
        },
        {
          label: "已取消",
          value: "-2"
        },
        {
          label: "退款中",
          value: "-3"
        },
        {
          label: "退款成功",
          value: "-4"
        }
      ],
    };
  },
  mounted() {
    this.getTableData();
    this.getStaffList()
  },
  methods: {
    getStaffList() {
				let params = {
					"keyword": '',
					"pageIndex": 1,
					"pageSize": 500,
				}
				this.$http.get('/api/Staff/List', params).then(res => {
					if (res.code == 0) {
						this.staffList = res.data.data;
					}
				})
			},
    // 自提核销
    handlePickUp() {
      this.drawerPickUp_state = true;
    },
    // 关闭弹窗
    handleUploadClose(val) {
      this.drawerPickUp_state = false;
      if (val.type == "submit") {
        this.getTableData();
      }
    },
    // 核销
    cancel(row) {
      this.order_id = row._id;
      this.dialogconfirm_state = true;
    },
    //核销确定
    confirmSort() {
      let params = {
        pick_up_store_code: this.pick_up_store_code
      };
      this.$http
        .get(
          process.env.VUE_APP_Url_order +
            "/api/OffLineOrder/get/pick_up_store_code",
          params
        )
        .then(res => {
          if (res.code == 0) {
            this.handleSunmitClick();
          }
        });
    },
    handleSunmitClick() {
      let params = {
        order_id: this.order_id
      };
      this.$http
        .get(
          process.env.VUE_APP_Url_order + "/api/OffLineOrder/havegood",
          params
        )
        .then(res => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "已收货"
            });
            this.dialogconfirm_state = false;
          }
        });
    },

    // 查看
    handleSeeClick(row) {
      let query = {
        id: row._id
      };
      if (row.order_type_id == 1) {
        this.$router.push({
          path: "/onlineOrder/onlineOrderSee",
          query
        });
      } else if (row.order_type_id == 8) {
        this.$router.push({
          path: "huotiDetail",
          query
        });
      } else if (row.order_type_id == 9) {
        this.$router.push({
          path: "xuniDetail",
          query
        });
      } else if (row.order_type_id == 3) {
        this.$router.push({
          path: "chufangDetail",
          query
        });
      } else if (row.order_type_id == 7) {
        this.$router.push({
          path: "wenzhenDetail",
          query
        });
      }
    },
    getTableData() {
      let params = {
        page_index: this.page.page,
        page_size: this.page.pageSize,
        keyword: this.keyword,
        state: this.state,
        order_source: "1",
        shop_id: this.$store.state.shopId
      };
      if (this.tab == 0) {
        params.order_type_id = "";
      } else if (this.tab == 1) {
        params.order_type_id = "1";
      } else if (this.tab == 2) {
        params.order_type_id = "8";
      } else if (this.tab == 3) {
        params.order_type_id = "9";
      } else if (this.tab == 4) {
        params.order_type_id = "3";
      } else if (this.tab == 5) {
        params.order_type_id = "7";
      }
      if (this.date != "") {
        params.starttime = this.$public.FTimeStr10(this.date[0]);
        params.endtime = this.$public.FTimeStr10(this.date[1]);
      }
      this.$http
        .post(process.env.VUE_APP_Url_order + "/api/CommonOrder/list", params)
        .then(res => {
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.page.total = res.data.count;
          }
        });
    },
    // 搜索
    handelComClick() {
      this.page.page = 1;
      this.getTableData();
    },
    //tab切换
    handleTabClick(type) {
      this.tab = type;
      this.page.peg = 1;
      this.getTableData();
    },
    //重置
    handleResetClick() {
      this.page.page = 1;
      this.keyword = "";
      this.state = "";
      this.getTableData();
    },
    // 分页方法
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
   
  }
};
</script>
  
<style lang="scss" scoped>
.page {
  padding: 16px 16px 65px 16px;
  height: 100%;
  box-sizing: border-box;
  position: relative;

  .screenLine {
    display: flex;
    align-items: center;

    .titleSelect {
      width: 130px;
      margin-right: 16px;
    }
  }
  .screenLineR {
    flex: 1;
    display: flex;
    justify-content: flex-end;

    .tabView {
      display: flex;
      align-items: center;
      width: 398px;
      height: 44px;
      background: rgba(239, 210, 187, 0.5);
      border-radius: 10px;
      justify-content: space-around;

      .tabItem {
        width: 90px;
        height: 36px;
        font-size: 14px;
        text-align: center;
        line-height: 36px;
        border-radius: 8px;
        cursor: pointer;
      }

      .tabActiveItem {
        width: 90px;
        height: 36px;
        font-size: 14px;
        text-align: center;
        line-height: 36px;
        border-radius: 8px;
        background: rgb(245, 136, 42);
        color: #fff;
      }
    }
  }
  .tableBox {
    padding: 16px;
    border-radius: 8px;
    background-color: #fff;
    box-sizing: border-box;
    margin-top: 16px;
    height: calc(100% - 56px);
  }
}
</style>